export default __webpack_public_path__ + "static/zenmap-5e09d6f14a91b69db186b6429d5ccc95.png";